import type { JSX } from "react";
import { useI18n, useSetLocale } from "../i18n/react.js";
import { LOCALES, type Locale } from "../i18n/index.js";

/**
 * ⭐ **DİL DEĞİŞTİRİCİ.**
 *
 * ### ⚠️ Neden gerekliydi?
 * İki katalog (tr/en) baştan tam ve tip güvenliydi ama dil **yalnız
 * `navigator.language`'dan** seçiliyordu. Tarayıcısı İngilizce olan bir
 * kullanıcı arayüzü Türkçeye çeviremiyordu ve tercih hiçbir yerde
 * saklanmıyordu.
 *
 * ### ⚠️ `<select>` DEĞİL, düğme grubu
 * İki seçenek için açılır liste, tek tıkla yapılabilecek işi iki tıka
 * çıkarır. `<select>` ayrıca mobilde tam ekran bir seçici açar.
 *
 * ⚠️ `aria-pressed` ile hangi dilin etkin olduğu ekran okuyucuya bildirilir;
 *    yalnız görsel vurgu yeterli değildir.
 */
export function LocaleSwitch(): JSX.Element {
  const i18n = useI18n();
  const setLocale = useSetLocale();

  return (
    <div data-locale-switch role="group" aria-label={i18n.t("locale.label")}>
      {LOCALES.map((l: Locale) => (
        <button
          key={l}
          type="button"
          // ⚠️ `lang` özniteliği ZORUNLU: ekran okuyucu "EN" düğmesini Türkçe
          //    telaffuzla okumamalı.
          lang={l}
          aria-pressed={i18n.locale === l}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
